export default {
    /**
     * User ID for mocking in prototype interface
     *
     */
    user_id: 4,
};
